import Controller from '@ember/controller';
import { service } from '@ember/service';
import type { IntlService } from 'ember-intl';
import type { ShowcaseContentTab } from 'walden-fast/components/showcase-content';
import { SERVICE_NAMES } from 'walden-fast/utils/constants/services';

export default class AppServicesWaldenBoxController extends Controller {
  @service('intl') declare intlService: IntlService;

  serviceName = SERVICE_NAMES.WALDEN_BOX;

  get tabs(): ShowcaseContentTab[] {
    return [
      {
        label: this.intlService.t('pages.waldenBox.teaser.tabs.reusableBox'),
        value: 'reusableBox',
        iconName: 'rotate-cw',
        title: this.intlService.t('pages.waldenBox.teaser.tabs.reusableBox'),
        description: this.intlService.t(
          'pages.waldenBox.teaser.tabs.reusableBox.description',
        ),
        image: '/assets/images/box_teaser_1.png',
        primaryCta: {
          type: 'activate-service',
          label: this.intlService.t(
            'pages.waldenBox.teaser.button.getWaldenBox',
          ),
          value: '',
        },
      },
      {
        label: this.intlService.t('pages.waldenBox.teaser.tabs.smartSensors'),
        value: 'smartSensors',
        iconName: 'radio',
        title: this.intlService.t('pages.waldenBox.teaser.tabs.smartSensors'),
        description: this.intlService.t(
          'pages.waldenBox.teaser.tabs.smartSensors.description',
        ),
        image: '/assets/images/box_teaser_2.png',
        primaryCta: {
          type: 'activate-service',
          label: this.intlService.t(
            'pages.waldenBox.teaser.button.getWaldenBox',
          ),
          value: '',
        },
      },
      {
        label: this.intlService.t(
          'pages.waldenBox.teaser.tabs.authorizedAccess',
        ),
        value: 'authorizedAccess',
        iconName: 'shield-check',
        title: this.intlService.t(
          'pages.waldenBox.teaser.tabs.authorizedAccess',
        ),
        description: this.intlService.t(
          'pages.waldenBox.teaser.tabs.authorizedAccess.description',
        ),
        image: '/assets/images/box_teaser_3.png',
        primaryCta: {
          type: 'activate-service',
          label: this.intlService.t(
            'pages.waldenBox.teaser.button.getWaldenBox',
          ),
          value: '',
        },
      },
      {
        label: this.intlService.t('pages.waldenBox.teaser.tabs.traceability'),
        value: 'traceability',
        iconName: 'git-compare',
        title: this.intlService.t('pages.waldenBox.teaser.tabs.traceability'),
        description: this.intlService.t(
          'pages.waldenBox.teaser.tabs.traceability.description',
        ),
        image: '/assets/images/box_teaser_4.png',
        primaryCta: {
          type: 'activate-service',
          label: this.intlService.t(
            'pages.waldenBox.teaser.button.getWaldenBox',
          ),
          value: '',
        },
      },
    ];
  }
}
